'use client';

import { useState } from "react";
import { Box, HStack, Stack, Text } from "@chakra-ui/react";
import { GiftBoxSelectorGroup } from "./GiftBoxSelectorGroup";
import { GiftBox } from "@/types/giftbox";
import { beautifyPrice } from "@/utils/price";

interface Props {
  blocks: GiftBox['blocks'];
  giftboxData: GiftBox;
}
export default function GiftBoxSelectorWrapper({ blocks, giftboxData }: Props) {
  const [price, setPrice] = useState<number>( 0);

  return (
    <Stack flex="1" maxW={{ base: "initial", md: "50%" }} px={{ base: "16px", md: "40px" }} py={"10px"} gap={"24px"}>
      <HStack id="product-info" gap={"16px"} justifyContent={"space-between"}>
        <Stack gap={"4px"}>
          {giftboxData.isNew && <Text textStyle={"bold16"} color={"brand"}>// NEW</Text>}
          <Text textStyle={"bold24"}>{giftboxData.name}</Text>
        </Stack>
        <HStack minW="232px" justifyContent={{ base: "flex-end", md: "flex-start" }} gap={"8px"}>
          <Text as={"b"} textStyle={"bold24"} className="product-price">{beautifyPrice(price)}</Text>
          {/* // TODO: Может добавить рассчет из GiftBoxSelectorGroup */}
          {/* <Text textStyle={"regularDel24"} className="product-price">{beautifyPrice(salePrice, false)}</Text> */}
        </HStack>
      </HStack>

      <GiftBoxSelectorGroup
        blocks={blocks}
        giftboxData={giftboxData}
        onSelectionsChange={(selections, currentPrice) => {
          if (typeof currentPrice === "number") setPrice(currentPrice);
        }}
      />
    </Stack>
  );
}